var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BaseModule } from './../commons/BaseModule';
import ComplexRoutes from './models/ComplexRoutes';
import Vue from 'vue';
import Router from 'vue-router';
import StoreModule, { getModule } from '../store';
import { getAppInstance } from '../app';
import ConfigStore from '../config/store/ConfigStore';
import RouterStore from './store/RouterStore';
import GoogleAnalyticsModule from '../google-analytics';
var RouterModule = (function (_super) {
    __extends(RouterModule, _super);
    function RouterModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.history = [];
        return _this;
    }
    RouterModule.prototype.preInstall = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var storeModule = options.appModule.getModuleByType(StoreModule);
            storeModule.store.registerModule('router', RouterStore);
            _this.googleAnalytics = options.appModule.getModuleByType(GoogleAnalyticsModule);
            Vue.use(Router);
            _this.router = new Router({
                scrollBehavior: function (to, from, savedPosition) {
                    return {
                        x: 0,
                        y: 0
                    };
                }
            });
            _this.router.beforeEach(_this.onBeforeEach.bind(_this));
            _this.router.afterEach(_this.onAfterEach.bind(_this));
            _this.complexRoutes = new ComplexRoutes();
            _this.complexRoutes.routes = [];
            Vue.prototype.$gotoRoute = _this.gotoRoute.bind(_this);
            Vue.prototype.$getRouteHistory = _this.getHistory.bind(_this);
            Vue.prototype.$goRouteBack = _this.goBack.bind(_this);
            resolve(true);
        });
    };
    RouterModule.prototype.finalizeInstall = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var convertedRoutes = _this.complexRoutes.getConvertedRoutes();
            console.log('complexRoutes', _this.complexRoutes);
            console.log('convertedRoutes', convertedRoutes);
            _this.router.addRoutes(convertedRoutes);
            options.appModule.appOptions.router = _this.router;
            resolve(true);
        });
    };
    Object.defineProperty(RouterModule.prototype, "store", {
        get: function () {
            if (!this._storeModule)
                this._storeModule = getAppInstance().getModuleByType(StoreModule);
            return this._storeModule.store;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RouterModule.prototype, "routerStore", {
        get: function () {
            if (!this._routerStore)
                this._routerStore = getModule(RouterStore);
            return this._routerStore;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RouterModule.prototype, "configStore", {
        get: function () {
            if (!this._configStore)
                this._configStore = getModule(ConfigStore);
            return this._configStore;
        },
        enumerable: false,
        configurable: true
    });
    RouterModule.prototype.gotoRoute = function (routeName, params) {
        var configStore = this.configStore;
        if (!params)
            params = {};
        var route = {
            name: routeName,
            params: params
        };
        console.log('gotoRoute', route);
        this.router.push(route);
    };
    RouterModule.prototype.getHistory = function (index) {
        var i = this.history.length + index - 1;
        if (i > this.history.length - 1 || i < 0)
            return undefined;
        return this.history[i];
    };
    RouterModule.prototype.gotoHistory = function (index) {
        var route = this.getHistory(index);
        if (!route)
            return false;
        console.log('gotoHistory', index, route);
        this.router.push({
            name: route.name,
            params: __assign({}, route.params)
        });
        return true;
    };
    RouterModule.prototype.goBack = function (routeName, params) {
        if (!this.gotoHistory(-1)) {
            this.gotoRoute(routeName, params);
        }
    };
    RouterModule.prototype.onBeforeEach = function (to, from, next) {
        console.log('beforeEach', to, from);
        var fullPath = to.meta && to.meta.fullPath ? to.meta.fullPath : to.fullPath;
        var gaData = {
            page_title: to.name,
            page_location: fullPath,
            page_path: fullPath,
        };
        this.googleAnalytics.sendGAEvent('page_view', gaData);
        if (to.name) {
            this.routerStore.setRouteValidity({
                isValid: true,
                route: to,
                reason: ''
            });
        }
        else {
            this.routerStore.setRouteValidity({
                isValid: false,
                route: to,
                reason: ''
            });
        }
        next();
    };
    RouterModule.prototype.onAfterEach = function (to, from, failure) {
        if (!failure) {
            this.history.push(to);
            if (this.history.length > 20)
                this.history.shift();
        }
    };
    return RouterModule;
}(BaseModule));
export default RouterModule;



//////////////////
// WEBPACK FOOTER
// ./src/modules/router/index.ts
// module id = null
// module chunks = 